import { TeamSwitcher } from "./TeamSwitcher";

/** Blocking "pick a team" state for the coaching/feedback/admin
 * shells.
 *
 * Rendered in place of a shell's content when the signed-in user has
 * multiple teams and hasn't picked one yet (`scope.selectionRequired`).
 * Without this gate the shells would render their own (empty or
 * stale-scoped) content, which is exactly the ambiguity the
 * header-switcher relocation set out to remove.
 */
export function TeamScopeGate() {
  return (
    <div
      data-testid="team-scope-gate"
      className="mx-auto flex max-w-md flex-col items-center gap-4 rounded border border-rule bg-elevated px-6 py-12 text-center"
    >
      <p className="font-display text-lg text-ink">Select a team to continue</p>
      <p className="text-sm text-ink-muted">
        You belong to more than one team. Pick the team you want to work
        with — coaching notes, clips, and admin views are scoped to it.
      </p>
      {/* Distinct testid prefix: the scope BAR's switcher renders on
       * the same page while the gate is up (#367). */}
      <TeamSwitcher testIdPrefix="team-scope-gate-switcher" />
    </div>
  );
}
